import React from 'react';
import PageWrapper from '@erkport/components/PageWrapper';
import {getMonths, getYears} from '@erkport/services/erkport';
import EuropeMapPage from './page';

const EuropeMap = () => {
  return (
    <PageWrapper yearsProvider={getYears} monthsProvider={getMonths}>
      {(props) => <EuropeMapPage {...props} />}
    </PageWrapper>
  );
};

export default EuropeMap;
